import React, {useCallback, useState} from "react";
import {Modal} from "react-bootstrap";
import {createQNA} from "../../Wizard/_redux/wizardCrud";
import Swal from "sweetalert2";

export function QnaCreateModal({ show, onHide, data, qnaData }) {
    const [text, setText] = useState("");
    const onChange = useCallback(
        (e) => {
            setText(e.target.value)
        },
        [],
    );
    
    const onClick = useCallback(
        () => {
            if(text === "") {
                Swal.fire({
                    title: "경고",
                    html: "문의 내용을 입력해주세요.",
                    icon: "warning",
                    heightAuto: false
                    })
                return false;
            }
            const createData = {
                t_storeidx: data.t_storeidx,
                t_orderidx: data.idx,
                contents: text
                // idx: data.idx,
                // contents: text,
            }

            createQNA(createData).then(response => {
                const result = response.data;
                if(result) {
                    onHide()
                    qnaData()
                }

            }).catch(error => {
                console.log(error)
                Swal.fire({
                    title: 'QnA 등록을 실패하였습니다.',
                    html:'시스템 관리자에게 문의 바랍니다.',
                    icon:'error'
                })
            })
        },
        [data, text, onHide, qnaData],
    );
    

    // console.log(data)
    return (
        <Modal show={show} onHide={onHide} centered>
            <Modal.Header >
                QNA
            </Modal.Header>
            <Modal.Body>
                질문 : <textarea className="form-control" onChange={onChange} />
            </Modal.Body>
            <Modal.Footer className="d-flex justify-content-end">
                <button className="form-control btn-primary" onClick={onClick}>문의하기</button>
            </Modal.Footer>
        </Modal>
    )
}